// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Typography } from '@mui/material';
import FormDialog from '../../components/Dialog/FormDialog';

interface RevokeDialogProps {
  open: boolean;
  onClose: () => void;
  onRevoke: (() => Promise<unknown>) | undefined;
}
export const CommercialAgreementRevokeDialog: React.FC<RevokeDialogProps> = ({
  open,
  onClose,
  onRevoke,
}) => {
  const handleSubmit = React.useCallback(() => {
    if (onRevoke) {
      return onRevoke().finally(() => {
        onClose();
      });
    }
    onClose();
    return Promise.resolve();
  }, [onClose, onRevoke]);
  return (
    <FormDialog
      open={open}
      title="Revoke Commercial Agreement"
      onCancel={onClose}
      onSubmit={handleSubmit}
      submitName="Revoke"
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography>Are you sure you want to revoke the commercial agreement?</Typography>
        <Typography>This would stop the billing of credentials</Typography>
      </Box>
    </FormDialog>
  );
};
